import { REQUEST_ACTION_CONNECT_SERVICE_REQUEST_ITEM } from '../../../Request.constants.actions'

export const REQUEST_BOARD_FULL_RELOAD_ACTIONS = [
  REQUEST_ACTION_CONNECT_SERVICE_REQUEST_ITEM,
]
